export const currencyBRL = 'BRL';
